import React from 'react'
import { Button } from 'react-bootstrap'

const WhiteGreenButton = ({ buttonName, onClick, actionName, variant, className, loadingMessage,isLoading, style }) => {
    return (
        <Button
            onClick={onClick}
            variant={variant}
            className={className}
            disabled={isLoading}
            style={style}
        >
            {isLoading ? loadingMessage : buttonName}
        </Button>
    )
}

export default WhiteGreenButton;